<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <form @submit.prevent="salvar">
      <q-card>
        <q-card-main>
          <q-tabs
            inverted
            v-model="abaSelecionada"
          >
            <!-- Tabs - notice slot="title" -->
            <!-- <q-tab
              default
              slot="title"
              label="Proxy"
              name="tabProxy"
              id="tabProxy"
            />
            <q-tab
              slot="title"
              label="Email"
              name="tabEmail"
              id="tabEmail"
            /> -->
            <q-tab
              slot="title"
              label="Sistema"
              name="tbSistema"
              id="tbSistema"
            />
            <q-tab
              slot="title"
              label="Relatórios"
              name="tbRelatorios"
              id="tbRelatorios"
            />
            <q-tab-pane name="tabProxy">
              <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refServidor"
                    name="refServidor"
                    ref="refServidor"
                    etiqueta="Servidor"
                    validacao="text | required"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    :tamanho="100"
                    v-model="paginaStatus.parametrosSistema.nomServidor"
                  ></g-input>
                </div>
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refPortaServidor"
                    name="refPortaServidor"
                    ref="refPortaServidor"
                    etiqueta="Porta do Servidor"
                    validacao="number | required"
                    mascara="numero"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    :tamanho="5"
                    v-model="paginaStatus.parametrosSistema.numPortaServidor"
                  ></g-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refNomUsuario"
                    name="refNomUsuario"
                    ref="refNomUsuario"
                    validacao="required | text"
                    etiqueta="Usuário"
                    :tamanho="100"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    v-model="paginaStatus.parametrosSistema.nomUsuario"
                  ></g-input>
                </div>
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refSenha"
                    name="refSenha"
                    ref="refSenha"
                    validacao="required | password"
                    tipo="password"
                    etiqueta="Senha"
                    :tamanho="50"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    v-model="paginaStatus.parametrosSistema.txtSenha"
                  ></g-input>
                </div>
              </div>
              <div class="row mrg-t-20">
                <div class="col-sm-6 col-xs-6">
                  <q-toggle
                    id="recaptcha"
                    name="recaptcha"
                    v-model="indRecaptcha"
                    label="Usa reCAPTCHA"
                    color="teal-8"
                    :disable="paginaStatus.desabilitarEdicao"
                    true-value="S"
                    false-value="N"
                    checked-icon="check"
                    unchecked-icon="clear"
                  />
                </div>
              </div>
            </q-tab-pane>
            <q-tab-pane name="tabEmail">
              <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refServidorEmail"
                    name="refServidorEmail"
                    ref="refServidorEmail"
                    etiqueta="Endereço do servidor SMTP"
                    validacao="text | required"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    :tamanho="100"
                    v-model="paginaStatus.parametrosSistema.nomServidorEmail"
                  ></g-input>
                </div>
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refPortaServidorEmail"
                    name="refPortaServidorEmail"
                    ref="refPortaServidorEmail"
                    etiqueta="Nº porta do servidor SMTP"
                    validacao="required"
                    mascara="numero"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    :tamanho="5"
                    v-model="paginaStatus.parametrosSistema.numPortaEmail"
                  ></g-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refTxtEmail"
                    name="refTxtEmail"
                    ref="refTxtEmail"
                    validacao="email | required"
                    etiqueta="Email do servidor SMTP"
                    :foco="false"
                    :tamanho="100"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    v-model="paginaStatus.parametrosSistema.txtEmail"
                  ></g-input>
                </div>
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refSenhaEmail"
                    name="refSenhaEmail"
                    ref="refSenhaEmail"
                    validacao="required | password"
                    tipo="password"
                    etiqueta="Senha do email do servidor SMTP"
                    :tamanho="50"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    v-model="paginaStatus.parametrosSistema.txtSenhaEmail"
                  ></g-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refNomUsuarioEmail"
                    name="refNomUsuarioEmail"
                    ref="refNomUsuarioEmail"
                    validacao="required | text"
                    etiqueta="Usuário do servidor SMTP (Caso não tenha utilize o Email)"
                    :tamanho="100"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    v-model="paginaStatus.parametrosSistema.nomUsuarioEmail"
                  ></g-input>
                </div>
                <div class="col-sm-6 col-xs-6 mrg-t-30">
                  <q-toggle
                    id="sistemaSessao"
                    name="sistemaSessao"
                    v-model="paginaStatus.parametrosSistema.conexaoSegura"
                    label="Servidor de Email SMTP exige conexão segura?"
                    color="teal-8"
                    :disable="paginaStatus.desabilitarEdicao"
                    :true-value="true"
                    :false-value="false"
                    checked-icon="check"
                    unchecked-icon="clear"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <button
                    class="btn-email"
                    @click="testarEmail"
                  >
                    <i class="fas fa-envelope fa-lg"></i>
                    TESTAR
                  </button>
                </div>
              </div>
            </q-tab-pane>
            <q-tab-pane name="tbSistema">
              <!-- <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <g-input
                    id="refNumTempoSessao"
                    name="refNumTempoSessao"
                    ref="refNumTempoSessao"
                    etiqueta="Tempo de sessão (em minutos)"
                    mascara="numero"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    :tamanho="3"
                    v-model="paginaStatus.parametrosSistema.numTempoSessao"
                  ></g-input>
                </div>
                <div class="col-sm-4 col-xs-4 mrg-t-30 mrg-l-20">
                  <q-toggle
                    id="sistemaSessao"
                    name="sistemaSessao"
                    v-model="indExpirarSessao"
                    label="Sessão sem expirar"
                    color="teal-8"
                    :disable="paginaStatus.desabilitarEdicao"
                    true-value="S"
                    false-value="N"
                    checked-icon="check"
                    unchecked-icon="clear"
                  />
                </div>
              </div> -->
              <div class="row">
                <div
                  class="col-sm-6 col-xs-6"
                  style="padding-right: 10px;"
                >
                  <g-autocomplete
                    id="refCidade"
                    name="refCidade"
                    ref="refCidade"
                    etiqueta="Cidade"
                    valor="codMunicipio"
                    :foco="false"
                    validacao="required | text"
                    descricaoPrimaria="nomMunicipio"
                    :api="apiCidade"
                    v-model="codMunicipio"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    permitirTextoLivre="true"
                  ></g-autocomplete>
                </div>
                <div class="col-sm-4 col-xs-4">
                  <g-select
                    id="refUf"
                    name="refUf"
                    ref="refUf"
                    etiqueta="UF"
                    validacao="required"
                    :itens="ufArray"
                    item-valor="codigo"
                    item-etiqueta="descricao"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    v-model="codUf"
                  ></g-select>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-sm-6 col-xs-6"
                  style="padding-right: 10px;"
                >
                  <g-autocomplete
                    id="refFormaSolicitacao"
                    name="refFormaSolicitacao"
                    ref="refFormaSolicitacao"
                    etiqueta="Forma de solicitação via Web"
                    valor="codFormaSolicitacao"
                    :foco="false"
                    validacao="required"
                    descricaoPrimaria="desFormaSolicitacao"
                    :api="apiformaSolicitacao"
                    v-model="codFormaSolicitacao"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    permitirTextoLivre="true"
                  ></g-autocomplete>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-xs-5 col-md-5">
                  <g-option
                    id="ativo"
                    name="ativo"
                    ref="refAtivo"
                    tipo="radio"
                    :option="arrayAtivoEnum"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    etiqueta="Obrigar telefone do requerente"
                    validacao="required"
                    v-model="indTelefoneRequerente"
                  ></g-option>
                </div>
                <div class="col-xs-5 col-md-5">
                  <g-option
                    id="pendencia"
                    name="pendencia"
                    ref="refPendencia"
                    tipo="radio"
                    :option="arrayAtivoEnum"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    etiqueta="Permitir que outros usuários alterem pendência"
                    validacao="required"
                    v-model="indPendenciaProcesso"
                  ></g-option>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-10 gvn-title-primary mrg-t-0">
                  Home page
                </div>
                <div class="col-xs-6 col-md-6">
                  <g-option
                    id="permissao"
                    name="permissao"
                    ref="refPermissao"
                    tipo="radio"
                    :option="arrayPermissao"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    validacao="required"
                    v-model="indPermissao"
                  ></g-option>
                </div>
              </div>
            </q-tab-pane>
            <q-tab-pane name="tbRelatorios">
              <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <g-select
                    id="refRelatorioMovimentacao"
                    name="refRelatorioMovimentacao"
                    ref="refRelatorioMovimentacao"
                    etiqueta="Imprimir relatório na movimentação do processo?"
                    validacao="required"
                    :itens="arrayImpressaoMovimentacao"
                    item-valor="codigo"
                    item-etiqueta="descricao"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    v-model="codImpressaoMovimentacao"
                  ></g-select>
                </div>
                <div class="col-sm-6 col-xs-6">
                  <g-select
                    id="refRelatorioAbertura"
                    name="refRelatorioAbertura"
                    ref="refRelatorioAbertura"
                    etiqueta="Imprimir relatório na abertura do processo?"
                    validacao="required"
                    :itens="arrayImpressaoAbertura"
                    item-valor="codigo"
                    item-etiqueta="descricao"
                    :foco="false"
                    :desabilitar="paginaStatus.desabilitarEdicao"
                    v-model="codImpressaoAbertura"
                  ></g-select>

                </div>
              </div>
            </q-tab-pane>
          </q-tabs>
        </q-card-main>
      </q-card>
    </form>
    <div class="col-12 text-right pad-20t-h10-80b">
      <q-btn
        id="btnSalvar"
        name="btnSalvar"
        round
        class="fixed"
        color="positive"
        icon="check"
        size="lg"
        @click="salvar"
        style="right: 18px; bottom:18px"
        v-show="!paginaStatus.desabilitarEdicao"
      >
        <q-tooltip>Salvar</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>
<script>
import api from 'components/util/api'
import util from 'components/util/util'
import msg from 'components/util/msg'
import utilHttp from 'components/util/utilHttp'
import GInput from 'components/util/gInput'
import GSelect from 'components/util/gSelect'
import GOption from 'components/util/gOption'
import constante from 'components/util/constante'
import GAutocomplete from 'components/util/gAutocomplete'
import GDatepicker from 'components/util/gDatepicker'
import GBreadcrumb from 'components/util/gBreadcrumb'

export default {
  data () {
    return {
      apiCidade: api.CIDADE,
      apiUf: api.BUSCAR_LISTA_UF,
      apiParametrosSistema: api.PARAMETROS_SISTEMA,
      apiEnviarEmail: api.PARAMETROS_SISTEMA_ENVIAR_EMAIL,
      apiformaSolicitacao: api.FORMA_SOLICITACAO,
      arrayAtivoEnum: constante.ATIVO_ENUM,
      chaveLocalStorage: 'aberturaProcesso',
      indRecaptcha: '',
      indTelefoneRequerente: 'N',
      indPendenciaProcesso: 'N',
      indExpirarSessao: '',
      abaSelecionada: '',
      codMunicipio: '',
      municipio: '',
      codUf: '',
      codFormaSolicitacao: '',
      formaSolicitacao: '',
      codImpressaoMovimentacao: '',
      codImpressaoAbertura: '',
      indPermissao: 'S',
      enviandoEmail: false,
      ufArray: [],
      arrayPermissao: [
        { label: 'Todos processos', value: 'T' },
        { label: 'Processos do Setor', value: 'S' },
        { label: 'Processos da Unidade', value: 'U' },
        { label: 'Processos do Órgão', value: 'O' }
      ],
      arrayImpressaoMovimentacao: [
        { codigo: 'S', descricao: 'SIM' }, { codigo: 'N', descricao: 'NÃO' },
        { codigo: 'P', descricao: 'PEDIR CONFIRMAÇÃO' }
      ],
      arrayImpressaoAbertura: [
        { codigo: 'S', descricao: 'SIM' }, { codigo: 'N', descricao: 'NÃO' },
        { codigo: 'P', descricao: 'PEDIR CONFIRMAÇÃO' }
      ],
      paginaStatus: {
        caminhoMigalha: [],
        parametrosSistema: {}
      }
    }
  },
  methods: {
    carregarSelects () {
      var self = this
      utilHttp.httpGet(self.apiUf, resposta => {
        var listaUfs = []
        listaUfs = resposta.body
        listaUfs.forEach(uf => {
          self.ufArray.push({
            codigo: uf.codUf,
            descricao: uf.nomUf
          })
        })
      })
    },
    testarEmail () {
      var self = this
      self.enviandoEmail = true

      let filtro =
        '?smtpHost=' +
        self.paginaStatus.parametrosSistema.nomServidorEmail +
        '&smtpPort=' +
        self.paginaStatus.parametrosSistema.numPortaEmail +
        '&remetenteEmail=' +
        self.paginaStatus.parametrosSistema.txtEmail +
        '&remetenteSenha=' +
        self.paginaStatus.parametrosSistema.txtSenhaEmail

      let url = self.apiEnviarEmail.concat(filtro)
      utilHttp.httpGet(url, resposta => {
        if (resposta.body) {
          util.exibirToastSucesso(msg.m(15))
        } else {
          util.exibirToastFalha(msg.m(16))
        }
        self.enviandoEmail = false
      })
    },
    verificarCampoNulo (campo) {
      if ((campo !== undefined && campo !== null) || campo === 0) {
        if (campo !== '') {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    validarComponentes () {
      var self = this
      var listaCamposVazios = []
      if (self.verificarCampoNulo(self.paginaStatus.parametrosSistema.nomServidor)) {
        listaCamposVazios.push('Servidor')
      }
      if (self.verificarCampoNulo(self.paginaStatus.parametrosSistema.numPortaServidor)) {
        listaCamposVazios.push('Porta do Servidor')
      }
      if (self.verificarCampoNulo(self.paginaStatus.parametrosSistema.nomUsuario)) {
        listaCamposVazios.push('Usuário')
      }
      if (self.verificarCampoNulo(self.paginaStatus.parametrosSistema.txtSenha)) {
        listaCamposVazios.push('Senha')
      }
      if (self.verificarCampoNulo(self.paginaStatus.parametrosSistema.nomServidorEmail)) {
        listaCamposVazios.push('Servidor de Email')
      }
      if (self.verificarCampoNulo(self.paginaStatus.parametrosSistema.numPortaEmail)) {
        listaCamposVazios.push('Porta do Servidor de Email')
      }
      if (self.verificarCampoNulo(self.paginaStatus.parametrosSistema.txtEmail)) {
        listaCamposVazios.push('Email')
      }
      if (self.verificarCampoNulo(self.paginaStatus.parametrosSistema.nomUsuarioEmail)) {
        listaCamposVazios.push('Usuário do Email')
      }
      if (self.verificarCampoNulo(self.paginaStatus.parametrosSistema.txtSenhaEmail)) {
        listaCamposVazios.push('Senha do Email')
      }
      if (self.verificarCampoNulo(self.codMunicipio)) {
        listaCamposVazios.push('Cidade')
      }
      if (self.verificarCampoNulo(self.codUf)) {
        listaCamposVazios.push('UF')
      }
      if (self.verificarCampoNulo(self.codFormaSolicitacao)) {
        listaCamposVazios.push('Formda de solicitação via Web')
      }

      if (self.verificarCampoNulo(self.codImpressaoMovimentacao)) {
        listaCamposVazios.push('Imprimir relatório na movimentação do processo?')
      }
      if (self.verificarCampoNulo(self.codImpressaoAbertura)) {
        listaCamposVazios.push('Imprimir relatório na abertura do processo?')
      }

      if (listaCamposVazios.length === 1) {
        // Apenas um componente inválido
        util.exibirToastAviso(
          'Favor preencher campo vazio: '.concat(listaCamposVazios[0])
        )
        return false
      } else if (listaCamposVazios.length > 1) {
        // Múltiplos componentes inválidos
        var campos = ''
        var count = 0
        listaCamposVazios.forEach(c => {
          count = count + 1
          if (count === listaCamposVazios.length) {
            campos = campos.concat(c).concat('. ')
          } else {
            campos = campos.concat(c).concat(', ')
          }
        })
        util.exibirToastAviso(
          'Favor preencher os campos Obrigatórios: '.concat(campos)
        )
        return false
      }
      return true
    },
    salvar () {
      var self = this
      if (!util.validarEmail(self.paginaStatus.parametrosSistema.txtEmail)) {
        util.exibirToastAviso('Favor preencher E-mail corretamente')
        return
      }
      self.paginaStatus.parametrosSistema.logo = self.file
      if (!self.enviandoEmail) {
        if (self.validarComponentes()) {
          self.paginaStatus.parametrosSistema.codUsuario = self.$login.getCodUsuario()
          self.paginaStatus.parametrosSistema.indRecaptcha = self.indRecaptcha
          self.paginaStatus.parametrosSistema.indExpirarSessao = self.indExpirarSessao
          if (!util.validarObjeto(self.paginaStatus.parametrosSistema.municipio)) {
            self.paginaStatus.parametrosSistema.municipio = { codMunicipio: '', nomMunicipio: '' }
          }
          self.paginaStatus.parametrosSistema.municipio.codMunicipio = self.codMunicipio
          if (!util.validarObjeto(self.paginaStatus.parametrosSistema.uf)) {
            self.paginaStatus.parametrosSistema.uf = { codUf: '', nomUf: '' }
          }
          self.paginaStatus.parametrosSistema.uf.codUf = self.codUf
          if (!util.validarObjeto(self.paginaStatus.parametrosSistema.formaSolicitacao)) {
            self.paginaStatus.parametrosSistema.formaSolicitacao = { codFormaSolicitacao: '', desFormaSolicitacao: '' }
          }
          self.paginaStatus.parametrosSistema.formaSolicitacao.codFormaSolicitacao = self.codFormaSolicitacao
          self.paginaStatus.parametrosSistema.indImpressaoMovimentacao = self.codImpressaoMovimentacao
          self.paginaStatus.parametrosSistema.indImpressaoAbertura = self.codImpressaoAbertura
          self.paginaStatus.parametrosSistema.indPermissaoHome = self.indPermissao
          self.paginaStatus.parametrosSistema.indTelefoneRequerente = self.indTelefoneRequerente
          self.paginaStatus.parametrosSistema.indPendenciaProcesso = self.indPendenciaProcesso
          utilHttp.httpPostCarregando(
            self.apiParametrosSistema,
            self.paginaStatus.parametrosSistema,
            resposta => {
              util.exibirToastSucesso(msg.m(3))
            }
          )
        }
      }
    },
    iniciarToggles () {
      var self = this
      // ind reCAPTCHA
      if (
        self.paginaStatus.parametrosSistema.indRecaptcha !== null &&
        self.paginaStatus.parametrosSistema.indRecaptcha !== undefined
      ) {
        self.indRecaptcha = self.paginaStatus.parametrosSistema.indRecaptcha
      } else {
        self.indRecaptcha = 'N'
      }

      // ind ExpirarSessão
      if (
        self.paginaStatus.parametrosSistema.indExpirarSessao !== null &&
        self.paginaStatus.parametrosSistema.indExpirarSessao !== undefined
      ) {
        self.indExpirarSessao =
          self.paginaStatus.parametrosSistema.indExpirarSessao
      } else {
        self.indExpirarSessao = 'N'
      }

      // ind PermissaoHome
      if (
        self.paginaStatus.parametrosSistema.indPermissaoHome !== null &&
        self.paginaStatus.parametrosSistema.indPermissaoHome !== undefined
      ) {
        self.indPermissao =
          self.paginaStatus.parametrosSistema.indPermissaoHome
      } else {
        self.indPermissao = 'S'
      }

      // ind TelefoneRequerente
      if (
        self.paginaStatus.parametrosSistema.indTelefoneRequerente !== null &&
        self.paginaStatus.parametrosSistema.indTelefoneRequerente !== undefined
      ) {
        self.indTelefoneRequerente = self.paginaStatus.parametrosSistema.indTelefoneRequerente
      } else {
        self.indTelefoneRequerente = 'N'
      }

      // ind TelefoneRequerente
      if (
        self.paginaStatus.parametrosSistema.indPendenciaProcesso !== null &&
        self.paginaStatus.parametrosSistema.indPendenciaProcesso !== undefined
      ) {
        self.indPendenciaProcesso = self.paginaStatus.parametrosSistema.indPendenciaProcesso
      } else {
        self.indPendenciaProcesso = 'N'
      }
    }
  },
  watch: {
    abaSelecionada (valor) {
      var self = this

      if (valor === 'tbSistema') {
        // if (self.paginaStatus.parametrosSistema.municipio != null) {
        //   setTimeout(() => {
        //     self.$refs['refCidade'].carregar(
        //       self.paginaStatus.parametrosSistema.municipio.codMunicipio,
        //       self.paginaStatus.parametrosSistema.municipio.nomMunicipio
        //     )
        //   }, 100)
        // } else {
        //   self.paginaStatus.parametrosSistema.municipio = {
        //     codMunicipio: '',
        //     nomMunicipio: ''
        //   }
        // }
        if (self.codMunicipio) {
          setTimeout(() => {
            let url = api.CIDADE.concat('/').concat(self.codMunicipio)
            utilHttp.httpGet(url, resposta => {
              self.municipio = resposta.body.nomMunicipio.toString()
              self.$refs['refCidade'].carregar(
                self.codMunicipio,
                self.municipio
              )
            })
          }, 100)
        }
        if (util.validarObjeto(self.paginaStatus.parametrosSistema.uf)) {
          if (self.paginaStatus.parametrosSistema.uf.termo) {
            setTimeout(() => {
              this.$refs['refUf'].carregar(
                this.paginaStatus.parametrosSistema.uf,
                this.paginaStatus.parametrosSistema.uf.termo
              )
            }, 100)
          }
        }

        // if (self.paginaStatus.parametrosSistema.uf != null) {
        //   self.codUf = self.paginaStatus.parametrosSistema.uf.codUf
        // } else {
        //   self.paginaStatus.parametrosSistema.uf = { codUf: '', nomUf: '' }
        // }

        // if (self.paginaStatus.parametrosSistema.formaSolicitacao != null) {
        //   setTimeout(() => {
        //     self.$refs['refFormaSolicitacao'].carregar(
        //       self.paginaStatus.parametrosSistema.formaSolicitacao.codFormaSolicitacao,
        //       self.paginaStatus.parametrosSistema.formaSolicitacao.desFormaSolicitacao
        //     )
        //   }, 100)
        // } else {
        //   self.paginaStatus.parametrosSistema.formaSolicitacao = {
        //     codFormaSolicitacao: '',
        //     desFormaSolicitacao: ''
        //   }
        // }

        if (self.codFormaSolicitacao) {
          setTimeout(() => {
            let url = api.FORMA_SOLICITACAO.concat('/').concat(self.codFormaSolicitacao)
            utilHttp.httpGet(url, resposta => {
              self.formaSolicitacao = resposta.body.desFormaSolicitacao.toString()
              self.$refs['refFormaSolicitacao'].carregar(
                self.codFormaSolicitacao,
                self.formaSolicitacao
              )
            })
          }, 100)
        }
      } else if (valor === 'tbRelatorios') {
        if (self.paginaStatus.parametrosSistema.indImpressaoMovimentacao != null) {
          self.codImpressaoMovimentacao = self.paginaStatus.parametrosSistema.indImpressaoMovimentacao
        } else {
          self.paginaStatus.parametrosSistema.indImpressaoMovimentacao = ''
        }
        if (self.paginaStatus.parametrosSistema.indImpressaoAbertura != null) {
          self.codImpressaoAbertura = self.paginaStatus.parametrosSistema.indImpressaoAbertura
        } else {
          self.paginaStatus.parametrosSistema.indImpressaoAbertura = ''
        }
      }
    },
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)

        // Estado
        // if (this.$refs['refUf']) {
        //   if (this.paginaStatus.operacao.descricao === 'Novo') {
        //     this.paginaStatus.parametrosSistema.uf.termo = this.$refs['refUf'].termo
        //   } else {
        //     this.paginaStatus.parametrosSistema.uf = this.$refs['refUf'].objetoSelecionado
        //   }
        // }
      },
      deep: true
    }
  },
  mounted () {
    var self = this
    utilHttp.httpGet(self.apiParametrosSistema, resposta => {
      if (resposta.body !== undefined && resposta.body !== '') {
        self.paginaStatus.parametrosSistema = resposta.body
      } else {
        self.paginaStatus.parametrosSistema = {
          caminhoMigalha: [],
          parametrosSistema: {
            municipio: { codMunicipio: '', nomMunicipio: '' },
            uf: { codUf: '', nomUf: '' },
            formaSolicitacao: { codFormaSolicitacao: '', desFormaSolicitacao: '' }
          }
        }
      }

      self.paginaStatus.caminhoMigalha.push({
        icone: 'fa fa-cogs',
        descricao: 'Parâmetro',
        rotaNome: 'parametrosSistema'
      })
      self.carregarSelects()
      self.iniciarToggles()

      self.paginaStatus.parametrosSistema.numTempoSessao = 0
      self.codMunicipio = util.validarObjeto(self.paginaStatus.parametrosSistema.municipio) ? self.paginaStatus.parametrosSistema.municipio.codMunicipio : ''
      self.codUf = util.validarObjeto(self.paginaStatus.parametrosSistema.uf) ? self.paginaStatus.parametrosSistema.uf.codUf : ''
      self.codFormaSolicitacao = util.validarObjeto(self.paginaStatus.parametrosSistema.formaSolicitacao) ? self.paginaStatus.parametrosSistema.formaSolicitacao.codFormaSolicitacao : ''
      self.codImpressaoMovimentacao = self.paginaStatus.parametrosSistema.indImpressaoMovimentacao
      self.codImpressaoAbertura = self.paginaStatus.parametrosSistema.indImpressaoAbertura
      self.abaSelecionada = 'tbSistema'
    })
  },
  components: { GBreadcrumb, GDatepicker, GAutocomplete, GOption, GSelect, GInput }
}
</script>
